// One playing card of a Blackjack hand, on a phone or on the bar. The face is
// cardFace()'s, passed through the controller: a known rank and suit, and whether the
// suit prints red. Each surface styles it in its own world.
export function PlayingCard({card}) {
  return (
    <span className={card.red ? "playing-card red" : "playing-card"}>
      <b>{card.rank}</b>
      <i>{card.suit}</i>
    </span>
  );
}
